import {IItemContent} from "@connox/typescript-library";
import * as React from "react";
import styles from "./ItemRow.module.scss";
import Image from "../../ProductSeries/Image";

interface IItemThumbProps {
  item: IItemContent;
}

const ItemThumb: React.FC<IItemThumbProps> = ({item}) => {
  const {url, title} = item;

  return (
    <div className={styles.itemThumb}>
      <a href={url} title={title}>
        <Image item={item} />
      </a>
    </div>
  );

};

export default ItemThumb;
